<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<myprofile-signup-ui-loading-indicator></myprofile-signup-ui-loading-indicator>
<router-outlet></router-outlet>
<p-toast [style]="toastStyle()"></p-toast>
